import "./Home.css";

import home1 from "../../Media/home/home1.jpg";
import home2 from "../../Media/home/home2.jpg";


import FadeInSection from "../../Components/FadeInSection/FadeInSection";

export default function Home() {
    return (
        <div className="home">
            <FadeInSection>
                <div className="homeBanner">
                    <div className="banner" ></div>
                </div>
            </FadeInSection>

            <div className="homeSectionContainer">
                <FadeInSection>
                    <div className="homeTextSection">
                        <p className="bold">
                            Herzlich Willkommen bei der Imkerei Willis Weinviertler BIO Honig!
                        </p>
                    </div>
                </FadeInSection>

                <FadeInSection>
                    <div className="homeSection1">
                        <div className="container1">
                            <div className="banner" />
                        </div>
                        <div className="container2">
                            <p>
                                Seit über 30 Jahren betreibe ich die Imkerei Willis Weinviertler BIO Honig.<br />
								An der Arbeit als Imker fasziniert es mich eng mit der Natur zusammenzuarbeiten und das Leben der Bienenstöcke zu begleiten.
                            </p>
                        </div>
                    </div>
                </FadeInSection>

                <FadeInSection>
                    <div className="homeSection2">
                        <div className="container1">
                            <p>
                                Mit viel Sorgfalt und Respekt kümmere ich mich um das Wohl meiner Bienenvölker <br />
								und versuche so nachhaltig Honig zu produzieren
                            </p>
                        </div>
                        <div className="container2">
                            <div className="banner"></div>
                        </div>
                    </div>
                </FadeInSection>

				<FadeInSection>
                    <div className="homeSection4">
                        <div className="banner" ></div>
                    </div>
                </FadeInSection>

                <FadeInSection>
                    <div className="homeTextSection">
                        <div>
                            <p>
                                Unterstützt werde ich dabei von meiner Familie, die meine Begeisterung teilt, und mich tatkräftig begleitet.
								Hierzu zählen meine Frau Monika, meine Söhne Jonas, Paul und Samuel, und die Großeltern Johanna, Andreas, Ferdinand und Hildegard
                            </p>
                        </div>

                    </div>
                </FadeInSection>

                <FadeInSection>
                    <div className="homeSection5">
                        <div className="container1">
                            <img src={home2} />
                        </div>
                        <div className="container2">
                            <div className="banner"></div>
                        </div>
                    </div>
                </FadeInSection>
            </div>
        </div>
    );
}
